module.exports = __webpack_public_path__ + "img/ez-theme-switcher-ic-withdraw-bg.7fb2c410.7fb2c410.png";